import { watchEffect } from "vue";
import { useQuery } from "@tanstack/vue-query";
import type { components } from "@scalty/contracts";

import { recordAcceptedExtensions } from "~/utils/datasetKinds";

type DatasetKindCapabilityList = components["schemas"]["DatasetKindCapabilityList"];

/**
 * What each kind of dataset accepts, asked of the side that decides it.
 *
 * The answer is recorded in `~/utils/datasetKinds` so every surface reads one list: a copy
 * kept in the portal drifted from the server's and cost the customer an upload before the
 * refusal arrived (W8-WALK). The list changes only when the platform learns to read a new
 * format, so it is fetched once and kept.
 */
export function useDatasetKindCapabilities() {
  const query = useQuery({
    queryKey: qk.datasetKinds(),
    queryFn: () => apiFetch<DatasetKindCapabilityList>("/dataset-kinds"),
    staleTime: Infinity,
  });

  watchEffect(() => {
    const kinds = query.data.value?.datasetKinds;
    if (kinds) recordAcceptedExtensions(kinds);
  });

  return query;
}
